// extracted by mini-css-extract-plugin
export default {"LastKeyGiverDropsView":"LastKeyGiverDropsView_LastKeyGiverDropsView__M504E"};